<!--
 * @Author: xing.huang
 * @Date: 2021-10-27 14:29:49
 * @LastEditTime: 2023-03-22 17:08:48
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\alarm\ExceptionList\editException.vue
 * 
-->
<template>
  <div>
    <el-dialog
      class="event-detail-dialog"
      :title="editForm.isRead ? '查看' : '编辑'"
      :lock-scroll="false"
      :visible.sync="isShowEditDialog"
      width="780px"
      center
      :close-on-click-modal="false"
      @close="cancelEdit"
    >
      <el-form :model="editForm" :rules="rules" ref="editForm" style="width:100%;" class="config_exception_edit_form">
        <div class="content-warp">
          <span class="head-title" style="margin-top: -14px;">事件详情</span>
          <div class="order-info" style="padding-top: 20px;">
            <div class="item">
              <span class="title ">事件编码：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
                <el-input size="small" disabled v-model="editForm.eventCode" maxlength="50"></el-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="title ">事件名称：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
                <el-input size="small" disabled v-model="editForm.eventName" maxlength="50"></el-input>
              </el-form-item>
            </div>

            <div class="item" v-if="editForm.anomalyCode == 'other_anomalies'">
              <span class="title ">提交人：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
                <el-input size="small" disabled v-model="editForm.submitName" maxlength="50"></el-input>
              </el-form-item>
            </div>

            <div class="item" v-if="editForm.anomalyCode != 'spot_inspection_delay' && editForm.anomalyCode != 'other_anomalies'">
              <span class="title ">工单号：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
                <el-input size="small" disabled v-model="editForm.workOrderCode" maxlength="50"></el-input>
              </el-form-item>
            </div>

            <div class="item" v-if="editForm.anomalyCode != 'spot_inspection_delay' && editForm.anomalyCode != 'other_anomalies'">
              <span class="title ">物料信息：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
                <el-input size="small" disabled v-model="editForm.materialInfo" maxlength="50"></el-input>
              </el-form-item>
            </div>

            <div class="item" v-if="editForm.anomalyCode != 'spot_inspection_delay' && editForm.anomalyCode != 'other_anomalies'">
              <span class="title ">材质：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
                <el-input size="small" disabled v-model="editForm.materialQualityName" maxlength="50"></el-input>
              </el-form-item>
            </div>

            <div
              class="item"
              v-if="
                editForm.anomalyCode == 'self_check_overtime' ||
                  editForm.anomalyCode == 'patrol_check_overtime' ||
                  editForm.anomalyCode == 'first_check_overtime' ||
                  editForm.anomalyCode == 'spot_inspection_delay'
              "
            >
              <span class="title ">设备信息：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
                <el-input size="small" disabled v-model="editForm.deviceInfo" maxlength="50"></el-input>
              </el-form-item>
            </div>

            <div
              class="item"
              v-if="
                editForm.anomalyCode != 'order_complete_overdue' &&
                  editForm.anomalyCode != 'order_starts_overdue' &&
                  editForm.anomalyCode != 'spot_inspection_delay' &&
                  editForm.anomalyCode != 'other_anomalies'
              "
            >
              <span class="title">工序名称：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
                <el-input size="small" disabled v-model="editForm.procedureName" maxlength="50"></el-input>
              </el-form-item>
            </div>

            <div
              class="item"
              v-if="
                editForm.anomalyCode == 'order_complete_overdue' ||
                  editForm.anomalyCode == 'order_starts_overdue' ||
                  editForm.anomalyCode == 'procedure_starts_overdue' ||
                  editForm.anomalyCode == 'procedure_complete_overdue'
              "
            >
              <span class="title " style="width: 110px;margin-left:-30px"
                >计划{{ editForm.anomalyCode == "order_starts_overdue" || editForm.anomalyCode == "procedure_starts_overdue" ? "开始" : "完工" }}时间：</span
              >
              <el-form-item class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
                <el-date-picker
                  v-if="editForm.anomalyCode == 'order_starts_overdue' || editForm.anomalyCode == 'procedure_starts_overdue'"
                  disabled
                  :format="editForm.anomalyCode == 'order_starts_overdue' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm'"
                  style="max-width:180px"
                  clearable
                  v-model="editForm.planStartTime"
                  type="datetime"
                  placeholder="选择日期时间"
                ></el-date-picker>
                <el-date-picker
                  v-else
                  disabled
                  :format="editForm.anomalyCode == 'order_complete_overdue' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm'"
                  style="max-width:180px"
                  clearable
                  v-model="editForm.planEndTime"
                  type="datetime"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
            </div>

            <div
              class="item"
              v-if="
                editForm.anomalyCode == 'procedure_starts_overdue' ||
                  editForm.anomalyCode == 'procedure_complete_overdue' ||
                  editForm.anomalyCode == 'spot_inspection_delay' ||
                  editForm.anomalyCode == 'other_anomalies'
              "
            >
              <span class="title ">触发时间：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
                <el-date-picker disabled format="yyyy-MM-dd HH:mm" style="max-width:180px" clearable v-model="editForm.triggerTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
              </el-form-item>
            </div>

            <div class="item" style="width: 100%;" v-if="editForm.anomalyCode == 'other_anomalies'">
              <span class="title" style="width: 98px;margin-left:-14px">异常内容：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '700px' } : { maxWidth: '140px' }">
                <el-input size="small" style="width: 508px;" disabled v-model="editForm.content" maxlength="50"></el-input>
              </el-form-item>
            </div>
            <div class="item" v-if="editForm.anomalyCode == 'other_anomalies'" style="margin:0"></div>

            <div class="item" v-if="editForm.anomalyCode == 'product_overstock'">
              <span class="title">积压数量：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
                <el-input size="small" disabled v-model="editForm.conditionQuantity" maxlength="50"></el-input>
              </el-form-item>
            </div>
            <div class="item" v-if="editForm.anomalyCode == 'product_dull'">
              <span class="title">呆滞时长：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '180px', minWidth: '140px' } : { maxWidth: '140px' }">
                <el-input size="small" disabled style="max-width:180px" v-model="editForm.conditionHour" maxlength="50"> </el-input>
                <span style="position: absolute;display: block;top: 0;right: -2.5em;">小时</span>
              </el-form-item>
            </div>

            <div class="item" v-if="editForm.anomalyCode == 'first_check_overtime'" style="margin-right: -28px;">
              <span class="title">规定时长：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '220px', mixWidth: '220px' } : { maxWidth: '140px' }">
                <el-input size="small" disabled style="max-width:180px" v-model="editForm.conditionMinute" maxlength="50"></el-input>分钟
              </el-form-item>
            </div>
            <div class="item" v-if="editForm.anomalyCode == 'self_check_overtime' || editForm.anomalyCode == 'patrol_check_overtime'">
              <span class="title" style="width: 110px;margin-left:-30px">规定{{ editForm.anomalyCode == "patrol_check_overtime" ? "子卷质量检" : "自检" }}时间：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
                <el-date-picker disabled format="yyyy-MM-dd HH:mm" style="max-width:180px" clearable v-model="editForm.checkTime" type="datetime" placeholder=""></el-date-picker>
              </el-form-item>
            </div>
            <div
              class="item"
              v-if="
                editForm.anomalyCode == 'order_complete_overdue' ||
                  editForm.anomalyCode == 'order_starts_overdue' ||
                  editForm.anomalyCode == 'product_dull' ||
                  editForm.anomalyCode == 'product_overstock'
              "
            >
              <span class="title ">触发时间：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
                <el-date-picker disabled format="yyyy-MM-dd HH:mm" style="max-width:180px" clearable v-model="editForm.triggerTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
              </el-form-item>
            </div>
            <div class="item">
              <span class="title ">归档时间：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
                <el-date-picker disabled format="yyyy-MM-dd HH:mm" style="max-width:180px" clearable v-model="editForm.endTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
              </el-form-item>
            </div>
            <div class="item">
              <span class="title">当前状态：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
                <el-select style="max-width:180px" disabled clearable size="small" v-model="editForm.status" maxlength="16" placeholder="请选择">
                  <el-option :label="item.name" :key="item.value" v-for="item in statusOptions" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="item" v-if="editForm.anomalyCode == 'first_check_overtime' || editForm.anomalyCode == 'self_check_overtime' || editForm.anomalyCode == 'patrol_check_overtime'">
              <span class="title">质检编码：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
                <el-input size="small" disabled v-model="editForm.qcTaskCode" maxlength="50"></el-input>
              </el-form-item>
            </div>

            <div class="item" style="width: 100%;margin-left: 20px;">
              <span class="title" style="width: 98px;margin-left:-14px">当前执行人：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '700px' } : { maxWidth: '140px' }">
                <el-input size="small" style="width: 508px;" disabled v-model="editForm.dutyUserName" maxlength="50"></el-input>
                <!-- <el-select style="max-width:180px"  multiple collapse-tags  clearable size="small" v-model="editForm.dutyUserList" maxlength="16" placeholder="请选择">
								<el-option v-for="item in userList" :key="item.value" :label="item.name" :value="item.value"></el-option>
							</el-select> -->
              </el-form-item>
            </div>
          </div>

          <span class="head-title" v-if="editForm.anomalyCode != 'spot_inspection_delay' && editForm.anomalyCode != 'other_anomalies'">扩展信息</span>
          <div class="order-info" style="padding-top: 20px;" v-if="editForm.anomalyCode != 'spot_inspection_delay' && editForm.anomalyCode != 'other_anomalies'">
            <div class="item" v-for="item in editForm.propertyExtendList" :key="item.id">
              <span class="title ">{{ item.propertyName }}：</span>
              <el-form-item class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }">
                <el-input size="small" disabled v-model="item.propertyValue" maxlength="50"></el-input>
              </el-form-item>
            </div>
          </div>

          <span class="head-title" v-if="editForm.status != 5 && !editForm.isRead">处理过程</span>
          <div class="event-handler" style="padding-top: 20px;" v-if="editForm.status != 5 && !editForm.isRead">
            <div class="item-warp" v-if="editForm.status == 2" style="width:100%;">
              <div class="item">
                <span class="title ">事件原因：</span>
                <el-form-item class="value" style="width: 520px;">
                  <el-input size="small" v-model="editForm.eventReason" maxlength="50"></el-input>
                </el-form-item>
              </div>
              <div class="item">
                <span class="title is-my-required" style="width:84px">处理方式：</span>
                <el-form-item class="value" prop="processMode" style="width: 520px;">
                  <el-select style="width: 100%;" clearable size="small" v-model="editForm.processMode" maxlength="16" placeholder="请选择">
                    <el-option :label="item.processMode" :key="item.id" v-for="item in dealList" :value="item.processMode"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="item">
                <span class="title is-my-required">处理人：</span>
                <el-form-item class="value" prop="dutyUserList" style="width: 520px;">
                  <el-select style="width: 100%;" multiple collapse-tags clearable size="small" v-model="editForm.dutyUserList" maxlength="16" placeholder="请选择">
                    <el-option v-for="item in userList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="item">
                <span class="title ">备注：</span>
                <el-form-item class="value" style="width: 520px;">
                  <el-input size="small" v-model="editForm.remark" maxlength="50"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="upload" v-if="editForm.status == 2" style="width:100%">
              <span class="title ">图片：</span>
              <div v-for="(item, index) in editForm.fileList" :key="item.id" class="file-item" style="margin-bottom: 10px;">
                <div v-if="!item.fileId" class="file-item-add">
                  <el-upload
                    :action="uploadUrl(-99)"
                    :before-upload="beforeUpload"
                    accept="image/jpg,image/jpeg,image/png"
                    :on-success="uploadComplete"
                    :show-file-list="false"
                    style="display: inline-block;"
                  >
                    <i class="el-icon-plus" style="width:100px;height:100px;margin-top: 0px;"></i>
                  </el-upload>
                </div>
                <div v-else class="file-icon-container" :style="{ backgroundImage: `url(${item.fileUrl})` }" @click="showFile(item.fileUrl)">
                  <div class="file-delete" @click.stop="deleteFile(item, index)"></div>
                </div>
              </div>
            </div>

            <div class="item" v-if="editForm.status != 2" style="padding-top: 20px;margin-left: -20px;">
              <span class="title ">备注：</span>
              <el-form-item class="value">
                <el-input size="small" style="width:640px" v-model="editForm.remark" maxlength="50"></el-input>
              </el-form-item>
            </div>
          </div>

          <div style="text-align: center;margin-top:20px" v-if="!editForm.isRead">
            <el-button :disabled="isSubmit" v-if="editForm.status == 0 || editForm.status == 6" type="primary" @click="submitEdit(0)">确 认</el-button>
            <el-button :disabled="isSubmit" v-if="editForm.status == 0 && !editForm.isReassignment" type="primary" @click="openReassignmentUser">确认并转派</el-button>
            <el-button :disabled="isSubmit" v-if="(editForm.status == 0 || editForm.status == 6) && editForm.configEvent.includes('handle')" type="primary" @click="submitEdit(10)"
              >确认并处理</el-button
            >
            <el-button :disabled="isSubmit" v-if="editForm.status == 1" type="primary" @click="submitEdit(2)">开始处理</el-button>
            <el-button :disabled="isSubmit" v-if="editForm.status == 2" type="primary" @click="submitEdit(3)">处理完成</el-button>
            <!-- <el-button v-if="editForm.status==2" type="primary" @click="submitEdit(30)">保存</el-button> -->
            <el-button :disabled="isSubmit" v-if="editForm.status == 3" type="primary" @click="submitEdit(4)">审核通过</el-button>
            <el-button :disabled="isSubmit" v-if="editForm.status == 3" type="primary" @click="submitEdit(5)">审核未通过</el-button>
            <el-button :disabled="isSubmit" v-if="editForm.status == 4" type="primary" @click="submitEdit(4)">审核通过</el-button>
            <el-button :disabled="isSubmit" v-if="editForm.status == 4" type="primary" @click="submitEdit(5)">审核未通过</el-button>
            <el-button @click="cancelEdit">取 消</el-button>
          </div>

          <!-- <span class="head-title">处理记录</span> -->
          <el-collapse v-model="activeName" accordion class="head-title" style="width: 100%;">
            <el-collapse-item title="处理记录" name="1">
              <div class="event-history" style="padding-top: 0px;">
                <div class="action-item" v-for="(item, index) in editForm.processList" :key="index">
                  <span style="display: inline-block;width: 80px;text-align: right;">{{ item.submitterName }}</span> <span style="padding-left:20px"> {{ parseTime(item.gmtModified) }}</span>
                  <span :style="{ paddingLeft: '20px', color: item.color }">{{ parseAction(item.action) }}</span>
                  <div v-if="item.action != 30 && item.action != 3">
                    <span style="display: inline-block;width: 80px;text-align: right;">备注</span>
                    <el-input style="display: inline-block;width: 600px;margin-left:20px" size="small" disabled v-model="item.remark" maxlength="50"></el-input>
                  </div>
                  <div v-if="item.action == 30 || item.action == 3">
                    <div class="item-warp" style="width:100%;">
                      <div class="item">
                        <span class="title ">事件原因：</span>
                        <el-form-item class="value" style="width: 520px;">
                          <el-input disabled size="small" v-model="item.eventReason" maxlength="50"></el-input>
                        </el-form-item>
                      </div>
                      <div class="item">
                        <span class="title ">处理方式：</span>
                        <el-form-item class="value" style="width: 520px;">
                          <el-input disabled size="small" :style="{ color: item.color }" v-model="item.processMode" maxlength="50"></el-input>
                        </el-form-item>
                      </div>
                      <div class="item">
                        <span class="title ">处理人：</span>
                        <el-form-item class="value" style="width: 520px;">
                          <el-input disabled size="small" v-model="item.handlersName" maxlength="50"></el-input>
                        </el-form-item>
                      </div>
                      <div class="item">
                        <span class="title ">备注：</span>
                        <el-form-item class="value" style="width: 520px;">
                          <el-input disabled size="small" v-model="item.remark" maxlength="50"></el-input>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="upload" style="width:100%">
                      <span class="title ">图片：</span>
                      <div v-for="(item, index) in item.fileList" :key="item.id" class="file-item" :class="{ marginLeft98: index == 5 }" style="margin-bottom: 10px;">
                        <div class="file-icon-container" :style="{ backgroundImage: `url(${item.fileUrl})` }" @click="showFile(item.fileUrl)"></div>
                      </div>
                    </div>
                  </div>
                  <hr style="border:1px #ccc dashed;margin: 10px 0px;" />
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="选择转派人" :lock-scroll="false" :visible.sync="isShowReassignmentUser" width="380px" center :close-on-click-modal="false" @close="closeReassignmentUser">
      <el-form :model="reassignmentForm" :rules="rules" ref="reassignmentForm" style="width:100%;" class="config_exception_edit_form">
        <div class="item">
          <span class="title is-my-required" style="width: 98px;margin-left:-14px">转派人：</span>
          <el-form-item class="value" :style="W ? { maxWidth: '180px' } : { maxWidth: '140px' }" prop="reassignmentUserId">
            <el-select style="max-width:180px" filterable clearable size="small" v-model="reassignmentForm.reassignmentUserId" maxlength="16" placeholder="请选择">
              <el-option v-for="item in userList" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div style="text-align: center;margin-top:20px">
        <el-button type="primary" @click="submitReassignmentUser">提 交</el-button>
        <el-button @click="closeReassignmentUser">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import CommonUtils from "../../../util/CommonUtils";
export default {
  name: "ExceptionConfigEdit",
  props: {
    isEdit: Boolean,
    editInfo: Object
  },
  data() {
    return {
      isShowReassignmentUser: false,
      actionOption: [
        //动作 0-已确认、1-已转派、2-开始处理、3-处理完成、4-审核通过、5-审核未通过、30-处理完成（保存）
        { name: "已确认", value: 0 },
        { name: "已转派", value: 1 },
        { name: "开始处理", value: 2 },
        { name: "处理完成", value: 3 },
        { name: "审核通过", value: 4 },
        { name: "审核未通过", value: 5 },
        { name: "处理完成", value: 30 }
      ],
      statusOptions: [
        { name: "待确认", value: 0 },
        { name: "待处理", value: 1 },
        { name: "处理中", value: 2 },
        { name: "待审核", value: 3 },
        { name: "审核中", value: 4 },
        { name: "已完结", value: 5 },
        { name: "未通过", value: 6 },
        { name: "已消除", value: 7 },
        { name: "已撤销", value: 8 }
      ],
      actionHistoryList: [
        { name: "任国晓", action: "开始处理", remark: "", time: "2021-12-02" },
        { name: "任国晓", action: "确认", remark: "", time: "2021-12-02" },
        { name: "任国晓", action: "转派", remark: "", time: "2021-11-06" }
      ],
      activeName: "0",
      userList: [],
      dealList: [],
      info: {},
      isShowEditDialog: false,
      isEventHandler: false,
      W: true,
      editForm: {
        qcTaskCode: "",
        eventType: null,
        deviceId: null,
        errCode: "",
        isStop: 1,
        procedureId: null,
        materialId: null,
        orderCode: null,
        count: null,
        userId: null,
        remark: "",
        anomalyCode: "order_complete_overdue",
        dutyUserList: [],
        configEvent: [],
        reassignmentUserId: null,
        fileList: [{ fileId: null, fileUrl: "" }],
        propertyExtendList: []
      },
      editFormTemp: {},
      reassignmentForm: {
        reassignmentUserId: null
      },
      isSubmit: false,
      rules: {
        reassignmentUserId: [{ required: true, message: "请选择转派人", trigger: "change" }],
        processMode: [{ required: true, message: "请选择处理方式", trigger: "change" }],
        dutyUserList: [{ required: true, message: "请选择处理人", trigger: "change" }]
      }
    };
  },

  async mounted() {
    // let w = document.documentElement.clientWidth || document.body.clientWidth;
    // w >= 1900 ? this.W = true : this.W = false
    // window.onresize = () => {
    // 	let w = document.documentElement.clientWidth || document.body.clientWidth;
    // 	w >= 1900 ? this.W = true : this.W = false
    // }
    this.loadUserList();
  },

  methods: {
    deleteFile: function(rowData, index) {
      let message = "此操作将删除改文件，删除后不可撤回，是否继续";
      this.$confirm(message, "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.editForm.fileList.splice(index, 1);
        let fileList = CommonUtils.cloneObj(this.editForm.fileList);
        let hasId = fileList.every(item => item.fileId);
        if (this.editForm.fileList.length == 9 && hasId) {
          let json = { fileId: null, fileUrl: null };
          fileList.push(json);
        }
        this.$set(this.editForm, "fileList", fileList);
        let form = CommonUtils.cloneObj(this.editForm);
        this.$set(this, "editForm", form);
        // this.$RequestUtil.post({
        //     url: '/api/fileSys/deleteFile',
        //     type:'sync',
        //     params: {
        //         id:rowData.fileId
        //     },
        //     success: (res) => {
        //         if(res.code != -1){
        //             this.$message({
        //                 type: 'success',
        //                 message: '删除成功!'
        //             });

        // 			this.editForm.fileList.splice(index, 1)
        // 			let fileList = CommonUtils.cloneObj(this.editForm.fileList)
        // 			let hasId = fileList.every(item=>item.fileId)
        // 			if(this.editForm.fileList.length==10&&hasId){
        // 				let json = {fileId:null,fileUrl:null}
        // 				fileList.push(json)
        // 			}
        // 			this.$set(this.editForm,'fileList',fileList)

        //         }else {
        //             this.$message({
        //                 type: 'error',
        //                 message: res.msg||res.message
        //             });
        //         }
        //     }
        // });
      });
    },

    uploadUrl: function(fileType, scope) {
      let res = "/api/file/upload?token=" + localStorage.getItem("token") + "&fileType=" + fileType;
      return res;
    },

    beforeUpload(file) {
      // if(!this.permission.btn_file_upload){
      //     this.$message({
      //         type:'error',
      //         message:`抱歉，您暂无文件上传权限`
      //     })
      //     return false
      //  }
      let fileSize = file.size / 1024 / 1024;
      fileSize = Math.round(fileSize * 100) / 100;
      if (fileSize >= 10) {
        this.$message({
          type: "error",
          message: `文件大小不能超过5M,当前上传${file.name}大小为${fileSize}M`
        });
        return false;
      }
      let testMsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testMsg === "jpg";
      const extension2 = testMsg === "png";
      const extension4 = testMsg === "jpeg";
      if (!extension && !extension2 && !extension4) {
        this.$message({
          message: "上传文件只能是 jpg, jpeg, png格式!",
          type: "warning"
        });
        return false;
      }
    },

    uploadComplete(response) {
      if (response.code == 0) {
        this.$message({
          type: "success",
          message: "上传成功"
        });
        let index = this.editForm.fileList.length - 1;
        this.$set(this.editForm.fileList[index], "fileId", response.data.id);
        this.$set(this.editForm.fileList[index], "fileUrl", response.data.url);
        let fileList = CommonUtils.cloneObj(this.editForm.fileList);
        if (index <= 8) {
          let json = { fileId: null, fileUrl: null };
          fileList.push(json);
        }
        this.$set(this.editForm, "fileList", fileList);
        let form = CommonUtils.cloneObj(this.editForm);
        this.$set(this, "editForm", form);
      } else {
        this.$message.error(response.msg || response.message);
      }
    },

    //传入文件名，返回文件对应路径
    getFilePath(fileName) {
      if (!fileName) {
        return;
      }
      let filePath = "";
      let arr = fileName.split(".");
      let suffix = arr[arr.length - 1];

      switch (true) {
        case suffix == "pdf" || suffix == "pptx":
          filePath = "../../../static/img/pdf.png";
          break;
        case suffix == "png" || suffix == "jpg" || suffix == "svg":
          filePath = "../../../static/img/pic.png";
          break;
        case suffix == "txt" || suffix == "doc" || suffix == "docx":
          filePath = "../../../static/img/txt.png";
          break;

        default:
          filePath = "../../../static/img/file.png";
      }
      return filePath;
    },

    showFile: function(url) {
      if (!url) {
        this.$message.warning("当前文件不存在");
        return;
      }
      let index = url.lastIndexOf(".");
      let ext = url.substr(index + 1).toLowerCase();
      //可直接被浏览器打开的文件类型
      let arr = ["pdf", "png", "jpg", "svg", "txt", "html", "js", "art", "au", "aiff", "xbf", "jpeg"];
      if (arr.includes(ext)) {
        window.open(url, "_blank");
      } else {
        window.location.href = url;
      }
    },

    async loadUserList(workerName) {
      let { data } = await this.$RequestUtil.getAsync({ url: "/api/select/listWorker", params: { workerName } });
      this.userList = data;
    },

    parseAction(type) {
      return (this.actionOption.find(item => item.value == type) || {}).name;
    },

    parseTime(time) {
      if (time) {
        return dayjs(time).format("YYYY-MM-DD HH:mm");
      }
    },

    closeReassignmentUser() {
      this.reassignmentForm.reassignmentUserId = null;
      if (this.$refs["reassignmentForm"]) {
        this.$refs["reassignmentForm"].resetFields();
      }
      this.isShowReassignmentUser = false;
    },

    openReassignmentUser() {
      this.isShowReassignmentUser = true;
    },

    submitReassignmentUser() {
      this.$refs["reassignmentForm"].validate(valid => {
        if (valid) {
          this.submitEdit(1);
          this.closeReassignmentUser();
        }
      });
    },

    closeEventHandler() {
      // this.reassignmentForm.reassignmentUserId = null
      // if(this.$refs['reassignmentForm']){
      // 	this.$refs['reassignmentForm'].resetFields()
      // }
      this.reassignmentForm.reassignmentUserId = null;
      this.$refs["reassignmentForm"].clearValidate();
      this.isEventHandler = false;
    },

    openEventHandler() {
      this.isEventHandler = true;
    },

    submitEventHandler(type) {
      this.submitEdit(type);
      this.closeEventHandler();
      // this.$refs['reassignmentForm'].validate((valid) => {
      //     if (valid) {
      // 		this.submitEdit(type)
      // 		this.closeEventHandler()
      // 	}
      // })
    },

    async loadProcessModeList() {
      let anomalyCode = this.editForm.anomalyCode;
      if (this.editForm.anomalyCode.includes("starts_overdue")) {
        anomalyCode = "starts_overdue";
      }
      if (this.editForm.anomalyCode.includes("complete_overdue")) {
        anomalyCode = "complete_overdue";
      }
      let { data, message, code, msg } = await this.$RequestUtil.getAsync({ url: "/api/eventProcessConfig/list", type: "sync", params: { anomalyCode } });
      if (code == 0) {
        return data;
      } else {
        this.$message.error(message || msg);
      }
    },

    async loadDetail(id) {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({ url: "/api/anomalyEvent/detail", params: { id } });
      if (code == 0) {
        return data;
      } else {
        this.$message.error(msg || message);
      }
    },

    async handleEdit() {
      this.editFormTemp = await this.loadDetail(this.editForm.id);
      this.editFormTemp.materialInfo = this.editFormTemp.materialName + "|" + this.editFormTemp.materialCode;
      let deviceName = "";
      if (this.editFormTemp.deviceName) {
        deviceName = this.editFormTemp.deviceName;
      }
      let deviceCode = "";
      console.log(deviceName, 77777, this.editFormTemp.deviceName, 8888);
      if (this.editFormTemp.deviceCode != null || this.editFormTemp.deviceCode != undefined) {
        deviceCode = this.editFormTemp.deviceCode;
      }
      if (!deviceCode && !deviceName) {
        this.editFormTemp.deviceInfo = "";
      } else {
        this.editFormTemp.deviceInfo = deviceName + "|" + deviceCode;
      }

      // this.editFormTemp.anomalyCode = 'procedure_starts_overdue'
      this.editFormTemp.dutyUserList = this.editFormTemp.dutyUserList.map(item => item.userId);
      this.editFormTemp.dutyUserName = this.editForm.dutyUserName;
      this.editFormTemp.fileList = [{ fileId: null, fileUrl: "" }];
      this.editForm = this.editFormTemp;
    },

    cancelEdit() {
      this.$refs["editForm"].clearValidate();
      this.$parent.isEdit = false;
      this.activeName = "0";
    },

    submitEdit(action) {
      this.$refs["editForm"].validate(valid => {
        if (valid) {
          // 执行事件操作 POST /anomalyEvent/doAction
          // 传参：{
          // 	"id"://事件ID
          // 	"action"://动作 0-确认、1转派、2-开始处理、3-处理完成（提交）、4-审核通过、5-审核未通过、10-确认并处理、20-确认并转派、30-处理完成（保存）
          // 	"reassignmentUserId"://转派人员ID（转派用到）
          // 	//下面的在执行处理完成提交或者处理完成保存用到
          // 	"eventReason"://事件原因
          // 	"handlersId"://实际处理人ID（多个用逗号分隔）
          // 	"handlersName"://实际处理人姓名（多人，用逗号分隔）
          // 	"processMode"://处理方式
          // 	"remark"://备注
          // 	"fileId"://文件ID
          // 	"fileUrl"://文件URL
          // }
          let handlersId = this.editForm.dutyUserList + "";
          let reassignmentUserId = null;
          let fileList = [];
          if (this.editForm.status == 2) {
            fileList = this.editForm.fileList.map(item => item.fileId);
          }
          if (action == 1) {
            reassignmentUserId = this.reassignmentForm.reassignmentUserId;
          }
          let params = {
            id: this.editForm.id,
            action,
            remark: this.editForm.remark,
            processMode: this.editForm.processMode,
            eventReason: this.editForm.eventReason,
            fileList,
            reassignmentUserId,
            handlersId
          };
          this.isSubmit = true;
          this.$RequestUtil.post({
            url: "/api/anomalyEvent/doAction",
            params,
            success: async res => {
              if (res.code == 0) {
                this.$message.success("提交成功");

                if (action == 10 || action == 2) {
                  // this.editForm.status=2
                  await this.handleEdit();
                  this.$parent.btnSearch();
                  if (action == 10) {
                    let username = localStorage.getItem("username");
                    this.$set(this.editForm, "dutyUserName", username);
                    console.log(this.editForm, 2222222);
                  }
                  let find = this.editForm.processList.find(item => item.action == 3 || item.action == 30);

                  if (find) {
                    // this.editForm.eventReason = find.eventReason
                    this.$set(this.editForm, "eventReason", find.eventReason);
                    // this.editForm.processMode = find.processMode
                    this.$set(this.editForm, "processMode", find.processMode);

                    // this.editForm.remark = find.remark
                    this.$set(this.editForm, "remark", find.remark);
                    // this.editForm.fileList = find.fileList
                    let tempList = CommonUtils.cloneObj(find.fileList);

                    if (tempList.length < 10) {
                      tempList.push({ fileId: null, fileUrl: "" });
                    }
                    this.$set(this.editForm, "fileList", tempList);
                    console.log(this.editForm, 121);
                  }
                  this.isSubmit = false;
                } else {
                  this.$parent.btnSearch();
                  this.cancelEdit();
                  this.isSubmit = false;
                }
              } else {
                this.$message.error(res.message || res.msg);
                this.isSubmit = false;
              }
              this.isSubmit = false;
            }
          });
        }
      });
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
    },

    handlePictureCardPreview(file) {
      // this.dialogImageUrl = file.url;
      // this.dialogVisible = true;
    },

    async loadUserList(workerName) {
      let { data } = await this.$RequestUtil.getAsync({ url: "/api/select/listWorker", params: { workerName } });
      this.userList = data;
    }
  },
  watch: {
    isEdit: async function(newVal, oldVal) {
      this.isShowEditDialog = this.isEdit;
      if (this.isEdit) {
        this.editForm = this.editInfo;
        this.$set(this.editForm, "fileList", this.editInfo.fileList);
        this.dealList = await this.loadProcessModeList();
        if (this.editForm.status == 2) {
          //处理中状态并且 处理记录有上次记录显示上次处理记录
          let find = this.editForm.processList.find(item => item.action == 3 || item.action == 30);
          if (find) {
            // this.editForm.eventReason = find.eventReason
            this.$set(this.editForm, "eventReason", find.eventReason);
            // this.editForm.processMode = find.processMode
            this.$set(this.editForm, "processMode", find.processMode);
            // this.editForm.remark = find.remark
            this.$set(this.editForm, "remark", find.remark);
            let tempList = CommonUtils.cloneObj(find.fileList);
            if (tempList.length < 10) {
              tempList.push({ fileId: null, fileUrl: "" });
            }
            this.$set(this.editForm, "fileList", tempList);
            // this.editForm.fileList = find.fileList
          }
        }

        this.editForm.processList.forEach(item => {
          this.$set(item, "color", "");
          console.log(item.action);
          if (item.action == 4) {
            this.$set(item, "color", "green");
          } else if (item.action == 5) {
            this.$set(item, "color", "red");
          }
        });
        this.isSubmit = false;
      }
    }
  }
};
</script>

<style scoped>
.content-warp .el-dialog__body {
  background: #f7f8fc;
}

.order-info,
.event-handler,
.event-history {
  background: #fff;
  /* display: flex; */
}
.head-title {
  font-size: 14px;
  color: #23272a;
  margin: 16px 0px 10px 0px;
  display: inline-block;
}
.title {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
  display: inline-block;
  text-align: right;
  width: 82px;
}
.is-my-required:before {
  content: "*";
  color: #f56c6c;
  left: 0px;
  font-size: 20px;
  position: relative;
  top: 6px;
}
.value {
  display: inline-block;
}
.order-info {
  display: flex;
  flex-wrap: wrap;
}
.order-info .item {
  /* width: 50%; */
  margin-left: 20px;
}
.order-info .item:nth-child(2n) {
  /* width: 50%; */
  margin-left: 60px;
}
.event-history {
  display: flex;
  flex-direction: column;
}
.file-icon-container {
  width: 100%;
  height: 100%;
  margin-top: 0px;

  background-size: cover;
  position: relative;
  cursor: pointer;
}
.file-item {
  width: 100px;
  height: 100px;
  border: 1px solid #ccc;
  margin-left: 10px;
}
.marginLeft98 {
  margin-left: 98px;
}
.el-icon-plus {
  width: 100px;
  height: 100px;
  margin-top: 0px;
  text-align: center;
  font-size: 40px;
  line-height: 100px;
}

.file-delete {
  position: absolute;
  top: -2px;
  right: 0px;
  width: 15px;
  height: 15px;
  background-image: URL("../../static/img/delete.png");
  background-size: cover;
  cursor: pointer;
}
.upload {
  display: flex;
  /* margin-left: 30px; */
  flex-wrap: wrap;
}
/* .action-item{
	padding: 10px 0px;
} */
.action-item span {
  line-height: 30px;
}
</style>
<style>
.config_exception_edit_form .el-input-group__append {
  padding: 0 10px;
}
.event-detail-dialog .el-dialog__body {
  background: #f7f8fc;
}
</style>



// WEBPACK FOOTER //
// src/views/alarm/ExceptionList/editException.vue